export const config = {
	"pwa": "https://skillsclub.coolgreet.de",
	"prodPwa": "https://app.skillsclub.com",
	"deeplink": "https://skillsclub.app.link",
	"appStoreLink": "https://apps.apple.com/us/app/skillsclub/id6443815634",
	"playStoreLink": "https://play.google.com/store/apps/details?id=com.skillsclub.app",
	"availableLangs": [
		"en",
		"de",
		"fr",
		"es"
	],
	"hideSidebarPublicPages": true,
	"publicPagesLang": false,
	"hideLogout": false,
	"hideSettingsPasswordReset": false,
	"atsAnonymous": true,
	"noIframeRediret": "",
	"showInstallPrompt": true,
	"showCredentialWallet": true,
	"hideRatingInMembers": true,
	"sameSiteAssets": true,
	"maxAppointmentBlockSize": 60,
	"liveTranslation": false,
	"liveTranslationProd": false,
	"benefitUrl": {
		"en": "https://skillsclub.com/#benefits",
		"de": "https://skillsclub.com/de/#benefits",
		"fr": "https://skillsclub.com/fr/#benefits",
		"es": "https://skillsclub.com/es/#benefits"
	},
	"linkedIn": {
		"clientId": "78vsq6ziw3gfkz"
	},
	"mobileAppId": "com.congreet.app2",
	"customScheme": "skillsclub",
	"assets": "https://skillsclub.coolgreet.de",
	"assetsProd": "https://app.skillsclub.com",
	"countryDropdown": {
		"app.skillsclub.com": {
			"communities": [
				655
			]
		},
		"v15.skillsclub.com": {
			"communities": [
				655
			]
		},
		"skillsclub.coolgreet.de": {
			"communities": [
				610
			]
		},
		"localhost": {
			"communities": [
				527
			]
		}
	},
	"trackingWhitelist": {
		"skillsclub.coolgreet.de": {
			"siteId": 3,
			"exclude": [
				"lost-password",
				"set-password",
				"login",
				"register",
				"toc",
				"credentials/",
				"credential/",
				"mail-setting",
				"deeplink",
				"unsubscribe",
				"preview-attendee-detail"
			],
			"communityWhitelist": {
				"610": 3
			}
		},
		"app.skillsclub.com": {
			"tracker": "https://matomo.skillsclub.com",
			"siteId": 4,
			"exclude": [
				"lost-password",
				"set-password",
				"login",
				"register",
				"toc",
				"credentials/",
				"credential/",
				"mail-setting",
				"deeplink",
				"unsubscribe",
				"preview-attendee-detail"
			],
			"communityWhitelist": {
				"655": 4
			}
		},
		"localhost": {
			"siteId": 1,
			"communityWhitelist": {
				"518": 2,
				"527": 1
			}
		}
	},
	"limitedMemberList": {
		"app.skillsclub.com": {
			"communities": [
				655
			]
		},
		"v15.skillsclub.com": {
			"communities": [
				655
			]
		},
		"skillsclub.coolgreet.de": {
			"communities": [
				610
			]
		},
		"localhost": {
			"communities": [
				527
			]
		}
	}
}